export default __webpack_public_path__ + "81509558576ec5e6f8c32eca80c2c0ec.png";